export default __webpack_public_path__ + "static/media/general.13c7845f.png";